import styled from "styled-components";
import Icon from "../../imagery/Icon";

export const StyledSelectedIcon = styled(Icon)`
	@keyframes scale-up-center {
		0% {
			transform: scale(0%);
		}
		30% {
			transform: scale(150%);
		}
		100% {
			transform: scale(100%);
		}
	}

	@keyframes scale-down-center {
		background: none;
		border: none;

		0% {
			transform: scale(150%);
		}
		30% {
			transform: scale(100%);
		}
		100% {
			transform: scale(0%);
		}
	}

	&.TrackingButton__icon--scale-up {
		animation: scale-up-center 600ms;
	}

	&.TrackingButton__icon--scale-down {
		animation: scale-down-center 600ms;
	}

	&.TrackingButton__icon--selected {
		transform: scale(100%);
	}

	transform: scale(0);
	position: absolute;
	top: 0;
	left: 0;

	> svg {
		stroke: ${(props) => props.theme.palette.hexFor("white")};
		stroke-width: 2px;
		filter: drop-shadow(0px 2px 8px rgba(238, 150, 9, 0.4))
			drop-shadow(0px 2px 4px rgba(29, 41, 72, 0.4));
	}
`;

export const StyledUnselectedIcon = styled(Icon)`
	position: absolute;
	overflow: visible;
	top: 0;
	left: 0;
	> svg {
		stroke: ${(props) => props.theme.palette.hexFor("neutral_300")};
		stroke-width: 1.9px;
		fill: transparent;
	}
`;

export const StyledInput = styled.input`
	position: absolute;
	width: 100%;
	height: 100%;
	margin: 0;
	opacity: 0;
`;
